module.exports = __webpack_public_path__ + "static/media/9DESA26.967d2b5e.jpg";